export const container =
  'min-h-full bg-white flex flex-1 flex-col overflow-y-scroll';
export const buttonIcon = 'h-4 w-4 text-white mr-2';
export const labelContainer =
  'flex flex 1 flex-row justify-between items-center mb-6 pt-2';

export const iconRound = 'rounded-full px-2 py-0.5 bg-alertMain mr-2';

export const dialogContent = 'h-full';
